import React, {useState} from 'react'
import styled from 'styled-components'

import {Flex} from "../../../components";

import Logo from '../../../assets/LogoText.png';
import {NavLink} from "react-router-dom";
import Media from 'react-media'

const Container = styled(Flex)`
  border-right: 1px solid #414568;
  padding: 30px;
`;

const Link = styled(NavLink)`
  color: #7178B2;
  padding-left: 12px;
  position: relative;
  margin: 12px 0;
  font-weight: 600;
  
  &.active {
    color: #fff;
  }

  &.active::after {
    content: '';
    position: absolute;
    left: 0;
    height: 100%;
    width: 3px;
    background: #FE8348;
  }
`;

const MobileToggle = styled.div`
  height: 30px;
  width: 50px;
  position: relative;
  z-index: 1000;
  div {
    position: absolute;
    left: 50%;
    width: 100%;
    border: 2px solid white;
    transform: translate(-50%, -50%);
    transition: transform 300ms, top 300ms 200ms;
    &.one {
      top: 25%;
    }
    &.two {
      top: 75%;
    }
  }

  ${props => props.isOpen && `
      div {
        top: 50%!important;
        transition: transform 200ms 300ms, top 200ms;
        &.one { transform: translate(-50%, -50%) rotate(45deg); }
        &.two { transform: translate(-50%, -50%) rotate(-45deg); }
      }
  `}
`;

const MobileLinkContainer = styled(Flex)`
  z-index: 1;
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  width: 100%;
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.5s cubic-bezier(1, 0, 0, 1);
  background: #101225;
  padding: 0 15px;
  @supports (-webkit-backdrop-filter: blur()) {
    background-color: rgba(16, 18, 37, 0.502);
    -webkit-backdrop-filter: blur(35px);
  }
  ${props => (props.isOpen ? `max-height: 1000px;transition: max-height 1s ease-in-out;` : '')};
`;


const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Media query={{ minWidth: 1000 }}>
      { matches =>
        matches ? (
          <Container w="205px" h="100%" minh="100vh" dir="column">
            <img src={Logo} alt='Trickle' width={100} />
            <Flex h="40px" />
            <Link to="/admin/licenses" activeClassName='active'>Licenses</Link>
            <Link to="/admin/types" activeClassName='active'>Types</Link>
            <Link to="/admin/releases" activeClassName='active'>Releases</Link>
            <Link to="/admin/key-paths" activeClassName='active'>Key Paths</Link>
            <Link to="/admin/configure" activeClassName='active'>Configure</Link>
            <Link to="/admin/downloads" activeClassName='active'>Downloads</Link>
            <Link to="/admin/waitlist" activeClassName='active'>Waitlist</Link>
          </Container>
        ) : (
          <>
            <Flex w="100%" align='center' style={{ background: '#101225', padding: 15}}>
              <MobileToggle isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
                <div className="one" />
                <div className="two" />
              </MobileToggle>
            </Flex>
            <MobileLinkContainer dir="column" isOpen={isOpen}>
              <Flex h="15px" />
              <Link onClick={() => setIsOpen(false)} to="/admin/licenses" activeClassName='active'>Licenses</Link>
              <Link onClick={() => setIsOpen(false)} to="/admin/types" activeClassName='active'>Types</Link>
              <Link onClick={() => setIsOpen(false)} to="/admin/releases" activeClassName='active'>Releases</Link>
              <Link onClick={() => setIsOpen(false)} to="/admin/key-paths" activeClassName='active'>Key Paths</Link>
              <Link onClick={() => setIsOpen(false)} to="/admin/configure" activeClassName='active'>Configure</Link>
              <Link onClick={() => setIsOpen(false)} to="/admin/downloads" activeClassName='active'>Downloads</Link>
              <Link onClick={() => setIsOpen(false)} to="/admin/waitlist" activeClassName='active'>Waitlist</Link>
              <Flex h="15px" />
            </MobileLinkContainer>
          </>
        )
      }
  </Media>
  )
}

export default Navbar;
